// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"fbadf101","644":"a5e4c307"}[chunkId] + ".css";
};